import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import pinia from "@/store";
import { registerComponents, registerPropertys } from "@/global/components";
import registerDirectives from "@/global/directives";
import registerGtag from "./plugins/gtag";
import "@/assets/icons";
import "ant-design-vue/dist/antd.less";

/* if (process.env.NODE_ENV === "development") {
  const { mockXHR } = require("@/mock");
  mockXHR();
} */
const app = createApp(App);
app
  .use(router)
  .use(pinia)
  .use(registerComponents)
  .use(registerPropertys)
  .use(registerDirectives)
  .use(registerGtag)
  .mount("#app");
